export default "__VITE_ASSET__DhhvMMQY__"